<template>
  <div class="cookie-bar" :class="isCookieBarShown ? '':'hide'">
    <p class="cookie-bar__text">
      Ta strona wykorzystuje pliki cookies m.in. do celów statystycznych. Jeżeli nie wyrażasz zgody na ich zapisywanie, wyłącz ich obsługę w ustawieniach swojej przeglądarki. Przeczytaj więcej w
      <a
        class="cookie-bar__privacy-policy-link"
        href="/polityka-prywatnosci"
        target="_blank"
        @click="show"
      >polityce cookies</a>.
    </p>
    <button class="cookie-bar__btn button button--light" @click="agreePPTerms">
      Rozumiem
      <img src="../assets/img/thumb_up.svg" alt="thumb up" />
    </button>
  </div>
</template>

<script>
import { bus } from "../main";

export default {
  name: "CookieBar",
  data: function() {
    return {
      isCookieBarShown: true
    };
  },
  methods: {
    agreePPTerms: function() {
      // set cookie
      this.setCookie("policy-privacy-agreed", true, 365);

      // hide cookie bar
      this.hideCookieBar();
    },
    setCookie: function(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    hideCookieBar: function() {
      this.isCookieBarShown = false;
    },
    show: function(e) {
      e.preventDefault();
      bus.$emit("showPP");
    }
  }
};
</script>

<style lang="scss" scoped>
.cookie-bar {
  display: flex;
  position: fixed;
  bottom: 0;
  right: 0;
  width: $main-width;
  padding: 30px 52px 30px 70px;
  justify-content: space-between;
  align-items: center;
  background-color: $black-color;
  color: $primary-color;
  animation: slideUpIn 0.5s ease-in-out;
  z-index: 25;

  &.hide {
    animation: slideDownOut 0.5s ease-in-out forwards;
  }

  &__text {
    padding-right: 5%;
    font-family: $font-family-text, sans-serif;
    font-size: 16px;
    line-height: 1.56;
    font-weight: 500;
  }

  &__privacy-policy-link {
    text-decoration: underline;
  }

  &__btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $black-color;

    img {
      transform: translateY(-1px);
    }

    &:hover {
      color: $black-color;
      img {
        transform: translateY(-1px) rotate(-14deg);
      }
    }
  }

  @media (max-width: $tablet) {
    left: 0;
    width: 100%;
    flex-direction: column;
    padding: 4% 6%;
    &__btn {
      margin-top: 15px;
    }
    &__text {
      font-size: 14px;
      padding-right: 0;
    }
  }
}
</style>